import { render, staticRenderFns } from "./NoStamp.vue?vue&type=template&id=20c8ed98&scoped=true&"
import script from "./NoStamp.vue?vue&type=script&lang=js&"
export * from "./NoStamp.vue?vue&type=script&lang=js&"
import style0 from "./NoStamp.vue?vue&type=style&index=0&id=20c8ed98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8ed98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c8ed98')) {
      api.createRecord('20c8ed98', component.options)
    } else {
      api.reload('20c8ed98', component.options)
    }
    module.hot.accept("./NoStamp.vue?vue&type=template&id=20c8ed98&scoped=true&", function () {
      api.rerender('20c8ed98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/NoStamp.vue"
export default component.exports